module.exports = __webpack_public_path__ + "static/media/fund.2634f5a4.jpeg";